import { FormattedMessage } from 'dibs-react-intl';

export const estimateTitle = (
    <FormattedMessage id="pdpPricingGuidance.estimateTitle" defaultMessage="1stDibs Estimate" />
);

export const estimateInfo = (
    <FormattedMessage
        id="pdpPricingGuidance.estimateInfo"
        defaultMessage="This estimate is generated using proprietary data models that analyze features of the item such as creator, material, and time period, as well as historical sales of comparable items. There is no guarantee the item will resell or appraise for this amount."
    />
);
